module.exports = __webpack_public_path__ + "7ab82d73888c2128824ae3189e1856fb.pdf";